import React from 'react';
import styled from 'styled-components';

import Dropdown, { StyledDropdownIcon, StyledContent } from '../../../Dropdown';
import Button from '../../../Button';
import Throbber from '../../../Throbber';

import { Transfer } from '@icons/dialer';

export type DepartmentType = {
  id: number;
  svg?: React.SVGProps<SVGSVGElement>;
  isReserve?: boolean;
  value: string;
};

export interface DepartmentsDropdownProps {
  className?: string;
  departments: DepartmentType[] | null;
  onToggle: ({ isOpen }: { isOpen: boolean }) => void;
  onChange: ({ queueId }: { queueId: number }) => void;
}

interface DepartmentsDropdownState {
  isOpen: boolean;
}

class DepartmentsDropdown extends React.PureComponent<
  DepartmentsDropdownProps,
  DepartmentsDropdownState
> {
  static button() {
    return (
      <StyledLabel>
        <StyledTransferIcon />
        Перевести на отдел
      </StyledLabel>
    );
  }

  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };

    this.handleToggleOpen = this.handleToggleOpen.bind(this);
    this.departmentRenderer = this.departmentRenderer.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleToggleOpen(isOpen) {
    const { onToggle } = this.props;

    this.setState({ isOpen });

    onToggle?.({ isOpen });
  }

  handleChange({ currentTarget }) {
    const { onChange } = this.props;

    this.setState({
      isOpen: false,
    });

    onChange?.({ queueId: currentTarget.dataset.id });
  }

  departmentRenderer() {
    const { departments } = this.props;

    if (!departments) {
      return <StyledThrobber size={16} color="#262729" />;
    }

    if (departments.length === 0) {
      return <StyledEmpty>Нет свободных отделов!</StyledEmpty>;
    }

    return departments.map(department => {
      const { id, svg, value, isReserve } = department;

      return (
        <StyledDepartment key={id} data-id={id} onClick={this.handleChange}>
          {svg && <StyledImage>{svg}</StyledImage>}
          {isReserve && <StyledReserve>Бронирование</StyledReserve>}
          <StyledName>{value}</StyledName>
        </StyledDepartment>
      );
    });
  }

  render() {
    const { isOpen } = this.state;

    return (
      <StyledDepartmentsDropdown
        {...this.props}
        headRenderer={DepartmentsDropdown.button()}
        contentRenderer={this.departmentRenderer()}
        onToggle={this.handleToggleOpen}
        open={isOpen}
      />
    );
  }
}

const StyledDepartmentsDropdown = styled(Dropdown)`
  color: #fff;
  font-size: 13px;
  border-radius: 4px;
  border: solid 1px #919499;
  background-color: #262729;

  ${StyledContent} {
    width: 423px;
    flex-wrap: wrap;
  }

  ${StyledDropdownIcon} {
    margin: 1px 8px 0 0;
  }
`;

const StyledLabel = styled.div`
  color: #fff;
  display: flex;
  padding: 10px 8px;
  white-space: nowrap;
`;

const StyledTransferIcon = styled(Transfer)`
  width: 23px;
  height: 19px;

  margin-right: 7px;
  path {
    stroke: white;
  }
`;

const StyledDepartment = styled(Button)`
  border: none;
  margin: 2px;
  align-items: center;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 133px;
  position: relative;
  width: 130px;
  flex-basis: 130px;
  flex-grow: 1;
  justify-content: flex-start;
`;

const StyledImage = styled.div`
  align-items: center;
  display: flex;
  height: 53px;
  position: absolute;
  top: 19px;
`;

const StyledName = styled.span`
  color: #17181a;
  font-size: 14px;
  position: absolute;
  top: 100px;
`;

const StyledReserve = styled.span`
  color: #4d4d4d;
  font-size: 10px;
  position: absolute;
  text-transform: uppercase;
  top: 85px;
`;

const StyledThrobber = styled(Throbber)`
  padding: 35px 0;
  position: relative;
`;

const StyledEmpty = styled.div`
  width: 100%;
  color: black;
  font-size: 14px;
  line-height: 70px;
  text-align: center;
`;

export default DepartmentsDropdown;
